export default {
  floatingTopMenu: {
    openSettings: 'Configurações',
    showAbout: 'Mostrar informações gerais',
    about: 'Sobre o ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'Openrouteservice para disastres',
    askOpenrouteservice: 'Ask openrouteservice',
    settingsTooltip: 'Clique aqui se quiser ajustar configurações da aplicação e ver outras opções'
  }
}
